export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Звідки"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Куди"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сума"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Переказати"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Переказ по своїх рахунках"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перекази всередині гаманця"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Рахунки відправника та одержувача повинні бути різними"])}
}